import { Tooltip } from '@chakra-ui/react'

Tooltip.defaultProps = {
  hasArrow: true,
  placement: 'top',
  color: 'light',
  bg: 'primary',
}
